import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import moment from 'moment';
import queryString from 'query-string';
import { Container } from 'reactstrap';

import {
  CLICK_DOWNLOAD_DUMP,
  GET_BULK_USERS,
  GET_BULK_USERS_EMPTY,
  GET_MEMBERSHIPS,
  GET_MEMBERSHIPS_EMPTY,
  GET_USER_CARDS,
  GET_USER_CARDS_EMPTY,
  UPDATE_CUSTOMER_DATA_EMPTY,
  UPDATE_USER_CARD_EMPTY,
} from '../../../../store/actions';
import { Loader } from '../../../Common';
import BreadcrumbTrail from '../../../Common/BreadcrumbTrail';
import { Constant } from '../../../Helpers/constant';
import Filter from './Filters/Filter';
import Table from './Tables/Table';
import cogoToast from 'cogo-toast';
import Memberships from '../UserManagement/Components/Modals/Memberships';
import MembershipsThriweApp from '../UserManagement/Components/Modals/MembershipsThriwe';
import UpdateUser from '../UserManagement/Components/Modals/UpdateUser';
import CustomCard from '../../RulesManagement/v2/Dashboard/Components/Card';
import totalCustomer from '../../../../assets/images/total-customer.png';

const ClientCustomerManagement = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  // Parse URL query parameters
  const { page = 1, perPageLimit = Constant.TABLE_PAGE_SIZE } = queryString.parse(location.search);

  const [projectId, setProjectId] = useState(Constant?.CURRENT_SELECTED_PROGRAM?.id);
  const [isMainPage, setIsMainPage] = useState(true);
  const [currentPageNumber, setCurrentPageNumber] = useState(Number(page) - 1); // `page` is 1-based
  const [currentSelectedCustomerDetails, setCurrentSelectedCustomerDetails] = useState([]);
  const [isMembershipsModal, setIsMembershipsModal] = useState(false);
  const [isMembershipsModalThriwe, setisMembershipsModalThriwe] = useState(false);
  const [isUpdateUserModal, setIsUpdateUserModal] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(Number(perPageLimit));
  const [isUserCardListPageShow, setIsUserCardListPageShow] = useState(false);
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cardData, setCardData] = useState([]);

  /* ---------------------------- REDUX STATES ---------------------------- */
  // Get Bulk User
  const { users, usersListLoading } = useSelector((state: any) => ({
    users: state?.BulkUsers?.data,
    usersListLoading: state?.BulkUsers?.loading,
  }));

  // Get User Cards
  const { userCards, userCardsLoading } = useSelector((state: any) => ({
    userCards: state?.UserCards?.data,
    userCardsLoading: state?.UserCards?.loading,
  }));

  // Update User Card
  const { updateUserCard, updateUserCardLoading } = useSelector((state: any) => ({
    updateUserCard: state?.UpdateUserCard?.data,
    updateUserCardLoading: state?.UpdateUserCard?.loading,
  }));

  // Get Memberships
  const { memberships, membershipsLoading } = useSelector((state: any) => ({
    memberships: state?.Memberships?.data,
    membershipsLoading: state?.Memberships?.loading,
  }));

  // Update Memberships
  const { UpdateMemberShip, UpdateMemberShipLoading } = useSelector((state: any) => ({
    UpdateMemberShip: state?.UpdateMembership?.data,
    UpdateMemberShipLoading: state?.UpdateMembership?.loading,
  }));

  // Update User
  const { updateUser, updateUserLoading } = useSelector((state: any) => ({
    updateUser: state.UpdateCustomer.data,
    updateUserLoading: state.UpdateCustomer.loading,
  }));

  // Download Dump
  const { downloadDumpLoading } = useSelector((state: any) => ({
    downloadDumpLoading: state?.DownloadDump?.loading,
  }));

  useEffect(() => {
    if (users !== null) {
      setCardData([{ name: 'Total Customers', count: users?.totalCount || 0, icon: totalCustomer }]);
    }
  }, [users]);

  useEffect(() => {
    if (userCards !== null) {
      if (userCards?.results?.length === 0 || userCards?.results === null) {
        cogoToast.error('No card found!');
        dispatch({
          type: GET_USER_CARDS_EMPTY,
        });
      } else {
        setIsMainPage(false);
        setIsUserCardListPageShow(true);
      }
    }
  }, [userCards]);

  useEffect(() => {
    if (
      memberships !== null &&
      !['THRIWE_APP', 'HSBC_BEACH_CLUB', 'GLOBE_TOYOTA', 'HDFC_BUNDLE', 'MASTERCARD_CL', 'ENBD_NATIONAL_DAY', 'MASTERCARD_FAB'].includes(
        Constant.PROJECT_CODE,
      )
    ) {
      setIsMembershipsModal(true);
    } else if (memberships !== null) {
      setisMembershipsModalThriwe(true);
    }
  }, [memberships]);

  useEffect(() => {
    if (updateUserCard !== null) {
      dispatch({
        type: UPDATE_USER_CARD_EMPTY,
      });

      dispatch({
        type: GET_USER_CARDS,
        payload: {
          urlParam: {
            userId: `${currentSelectedCustomerDetails?.userId}`,
          },
        },
      });
    }
  }, [updateUserCard]);

  useEffect(() => {
    if (UpdateMemberShip != null) {
      if (
        ['THRIWE_APP', 'HSBC_BEACH_CLUB', 'GLOBE_TOYOTA', 'HDFC_BUNDLE', 'MASTERCARD_CL', 'ENBD_NATIONAL_DAY', 'MASTERCARD_FAB'].includes(
          Constant.PROJECT_CODE,
        )
      ) {
        dispatch({
          type: GET_MEMBERSHIPS,
          payload: {
            urlParam: {
              user_id: `${currentSelectedCustomerDetails?.userId}`,
            },
          },
        });
      } else {
        dispatch({
          type: GET_MEMBERSHIPS,
          payload: {
            urlParam: {
              userId: `${currentSelectedCustomerDetails?.userId}`,
            },
          },
        });
      }
      dispatch({
        type: GET_USER_CARDS_EMPTY,
      });
    }
  }, [UpdateMemberShip]);

  useEffect(() => {
    if (updateUser !== null) {
      setIsUpdateUserModal(false);
      updateURLParams({ page: 1 });
      dispatch({
        type: UPDATE_CUSTOMER_DATA_EMPTY,
      });
    }
  }, [updateUser]);

  useEffect(() => {
    // Sync state with URL
    const { page, perPageLimit } = queryString.parse(location.search);
    setCurrentPageNumber(Number(page || 1) - 1); // Default to 1-based page
    setRowsPerPage(Number(perPageLimit || Constant.TABLE_PAGE_SIZE));
  }, [location.search]);

  useEffect(() => {
    dispatch({
      type: GET_BULK_USERS,
      payload: {
        urlParam: {
          pageIndex: currentPageNumber * rowsPerPage,
          pageSize: rowsPerPage,
        },
        data: {
          include: ['address'],
          ...currentlyAppliedFilters,
        },
      },
    });
  }, [currentlyAppliedFilters, currentPageNumber, rowsPerPage, dispatch]);

  useEffect(() => {
    if (
      userCardsLoading ||
      usersListLoading ||
      updateUserCardLoading ||
      membershipsLoading ||
      downloadDumpLoading ||
      updateUserLoading ||
      UpdateMemberShipLoading
    ) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [
    userCardsLoading,
    usersListLoading,
    updateUserCardLoading,
    membershipsLoading,
    downloadDumpLoading,
    updateUserLoading,
    UpdateMemberShipLoading,
  ]);

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const tableActionHandler = params => {
    setCurrentSelectedCustomerDetails(params?.details);

    if (params?.actionType === `CARD_LIST`) {
      dispatch({
        type: GET_USER_CARDS,
        payload: {
          urlParam: {
            userId: `${params?.details?.userId}`,
          },
        },
      });
    } else if (params?.actionType === `MEMBERSHIPS`) {
      dispatch({
        type: GET_MEMBERSHIPS,
        payload: {
          urlParam: {
            userId: `${params?.details?.userId}`,
          },
        },
      });

      dispatch({
        type: GET_USER_CARDS_EMPTY,
      });
    } else if (params?.actionType === `UPDATE`) {
      setIsUpdateUserModal(true);
    } else if (params?.actionType === `MEMBERSHIPS_THRIWE_APP`) {
      dispatch({
        type: GET_MEMBERSHIPS,
        payload: {
          urlParam: {
            user_id: `${params?.details?.userId}`,
          },
        },
      });
    }
  };

  const onCloseMembershipModal = () => {
    setIsMembershipsModal(false);
    setisMembershipsModalThriwe(false);

    dispatch({
      type: GET_USER_CARDS_EMPTY,
    });

    dispatch({
      type: GET_MEMBERSHIPS_EMPTY,
    });
  };

  const onCloseUserModal = () => {
    setIsUpdateUserModal(false);
  };

  /* ---------------------------- PAGINATION HANDLER ---------------------------- */
  const paginationHandler = pageNumber => {
    updateURLParams({ page: pageNumber + 1 });

    dispatch({
      type: GET_USER_CARDS_EMPTY,
    });

    dispatch({
      type: GET_MEMBERSHIPS_EMPTY,
    });
  };

  /* ---------------------------- DOWNLOAD DUMP HANDLER ---------------------------- */
  const downloadDumpHandler = () => {
    dispatch({
      type: CLICK_DOWNLOAD_DUMP,
      payload: {
        urlParam: {
          projectId,
          downloadType: 3,
        },
        data: currentlyAppliedFilters,
        code: [
          'HSBC_BEACH_CLUB',
          'ALRAJHI_GOLF',
          'GLOBE_TOYOTA',
          'ENBD_NATIONAL_DAY',
          'MASTERCARD_FAB',
          'THRIWE_APP',
          'MASTERCARD_CL',
          'HDFC_BUNDLE',
          'ALRAJHI_VALET',
          'ENBD_VALET',
          'SAB_LANDMARK',
        ].includes(Constant.PROJECT_CODE)
          ? true
          : false,
      },
    });
  };

  const updateURLParams = newParams => {
    const currentParams = queryString.parse(location.search);

    const updatedParams = {
      page: currentPageNumber + 1, // Default to current page
      perPageLimit: rowsPerPage, // Default to current rowsPerPage
      ...currentParams, // Merge existing query parameters
      ...newParams, // Override with new parameters
    };

    const newUrl = queryString.stringify(updatedParams);

    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  const filterSubmitHandler = filters => {
    setCurrentlyAppliedFilters(filters);
    dispatch({
      type: GET_BULK_USERS_EMPTY,
    });
    updateURLParams({ page: 1 });
  };

  const handleRowsPerPageChange = newRowsPerPage => {
    updateURLParams({ page: 1, perPageLimit: newRowsPerPage });
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/client/dashboard`);
    }
  };

  return (
    <>
      {loading && <Loader />}
      {isMembershipsModal && <Memberships data={memberships?.results} onCloseHandler={onCloseMembershipModal} />}
      {isMembershipsModalThriwe && <MembershipsThriweApp data={memberships?.results} onCloseHandler={onCloseMembershipModal} />}
      {isUpdateUserModal && <UpdateUser data={currentSelectedCustomerDetails} setModal={setIsUpdateUserModal} onCloseHandler={onCloseUserModal} />}
      <div className="page-content">
        <Container fluid className="position-relative">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0' }}>
            <BreadcrumbTrail
              title="Customer Management"
              navigationby={breadcrumNavigationHandler}
              navigation={[`Dashboard`, `Customer Management`]}
            />
            <Filter filterHandler={filterSubmitHandler} />
          </div>

          <div className="scrollable-1 mt-3 mb-3">
            <div className="d-inline-flex gap-4">
              {cardData?.map((item, key) => (
                <div className="card dashboard-globe-toyota-card" key={key}>
                  <CustomCard cardData={item} />
                </div>
              ))}
            </div>
          </div>

          <Table
            data={users?.users ?? []}
            totalCount={users?.totalCount}
            pageNumber={currentPageNumber}
            limit={rowsPerPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            handlePageChange={paginationHandler}
            dumpDownload={downloadDumpHandler}
            actionHandler={tableActionHandler}
          />
        </Container>
      </div>
    </>
  );
};

export default ClientCustomerManagement;
